import { render } from "./ADJ_1.vue?vue&type=template&id=694d5052&scoped=true"
import script from "./ADJ_1.vue?vue&type=script&lang=js"
export * from "./ADJ_1.vue?vue&type=script&lang=js"

import "./ADJ_1.vue?vue&type=style&index=0&id=694d5052&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694d5052"]])

export default __exports__